import {
  LANDING_SEPARATOR_TYPE_BOOKS_SET,
  MAP_LANDING_BOOKS_SET_ID_TO_CONFIG,
  TYPES_BOOKS_SET,
} from "@/utils/landing/landing.constants";
import { DEFAULT_LANGUAGE, LANG_CODE_EN } from "@/shared/utils/multilang/constants";

export const isLandingIdTypeBooksSet = (landingId) => {
  if (!landingId) {
    return false;
  }

  return TYPES_BOOKS_SET.some((type) =>
    landingId.startsWith(type + LANDING_SEPARATOR_TYPE_BOOKS_SET),
  );
};

export const getBookSetConfigByBookIdOriginal = (bookIdOriginal) => {
  const nBookIdOriginal = parseInt(bookIdOriginal);

  return Object.values(MAP_LANDING_BOOKS_SET_ID_TO_CONFIG).find((config) =>
    config.order[LANG_CODE_EN].includes(nBookIdOriginal),
  );
};

export const getBookSetIdByBookIdOriginal = (bookIdOriginal) => {
  const nBookIdOriginal = parseInt(bookIdOriginal);

  return Object.keys(MAP_LANDING_BOOKS_SET_ID_TO_CONFIG).find((id) =>
    MAP_LANDING_BOOKS_SET_ID_TO_CONFIG[id].order[LANG_CODE_EN].includes(nBookIdOriginal),
  );
};

const filterBookTitlesByLang = (bookTitles, lang) => {
  if (!bookTitles) {
    return null;
  }

  if (!lang) {
    return bookTitles;
  }

  const suitableBookTitles = bookTitles.filter((b) => b.lang === lang);

  return suitableBookTitles.length
    ? suitableBookTitles
    : bookTitles.filter((b) => b.lang === DEFAULT_LANGUAGE);
};

const getBookENIdNormalized = (book) => (book?.idEn ? +book.idEn.substring(1) : book.book_id);
const sortBookTitlesByBookSetConfig = (bookTitles, bookSetConfig, orderLangPreferred) => {
  if (bookTitles && bookSetConfig) {
    const order = bookSetConfig.order[orderLangPreferred] || bookSetConfig.order[DEFAULT_LANGUAGE];
    if (order) {
      return bookTitles
        .filter((b) => order.includes(getBookENIdNormalized(b)))
        .sort((a, b) =>
          order.indexOf(getBookENIdNormalized(a)) > order.indexOf(getBookENIdNormalized(b))
            ? 1
            : -1,
        );
    }
  }

  return bookTitles;
};

export const filterByLangAndSortBookTitles = (bookTitles, config, lang) => {
  const listFiltered = config?.onlyOneLang ? bookTitles : filterBookTitlesByLang(bookTitles, lang);
  return sortBookTitlesByBookSetConfig(listFiltered, config, lang);
};
